module.exports = __webpack_public_path__ + "static/media/vast-vpaid-support-icon.41bd26cf.svg";